import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const CurrencyMarks = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="9.5" stroke="currentColor" />
    <path
      d="M10 8.92857L12.2223 5H14.4445V9.28571H16.6667V11.4286H14.4445V15H12.2223V9.28571C12.2207 9.35363 10.7408 12.1429 10.7408 12.1429H9.2593L7.77782 9.28571V15H5.5556V11.4286H3.33337V9.28571H5.5556V5H7.77782L10 8.92857Z"
      fill="currentColor"
    />
  </svg>,
  'CurrencyMarks'
);
